module.exports = "../static/media/banner.73cbb7ac.png";